import styled from 'styled-components';
import { resolveHeight } from '../utils/scrollHelpers';

export const StyledScrollBox = styled.div`
  max-height: ${props => resolveHeight(props.height)};
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  
  /* Custom scrollbar for better UI on Webkit browsers */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${props => (props.theme.colors && props.theme.colors.text && props.theme.colors.text.muted) || '#ccc'};
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: ${props => (props.theme.colors && props.theme.colors.text && props.theme.colors.text.primary) || '#999'};
  }
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/ScrollBox/components/ScrollBoxStyles.js